import { Box } from "@mui/material";
import React from "react";

const ServerErrorPage = () => {
  return <Box>Error del servidor </Box>;
};

export default ServerErrorPage;
